import { getCollectionByBrand } from '@fedsim/imports'
import { useDispatch } from 'react-redux'
import {
  createBrand,
  deleteBrand,
  generateWrestlers,
  generateChampionships,
  generateFeuds,
  generateReigns,
  generateArenas,
  generateFactions,
  generateShows
} from '@fedsim/actions'
import { trackEv, Categories, Actions } from 'analytics'

export function useBrandImporter() {
  try {
    const dispatch = useDispatch()

    const onCreate = brand => {
      const result = getCollectionByBrand(brand.id)
      const { arenas, wrestlers, championships, shows, reigns, factions, feuds } = result

      dispatch(createBrand(brand))
      dispatch(generateWrestlers(wrestlers))
      dispatch(generateArenas(arenas))
      dispatch(generateChampionships(championships))
      dispatch(generateShows(shows))
      dispatch(generateFactions(factions))
      dispatch(generateReigns(reigns))
      dispatch(generateFeuds(feuds))

      trackEv(Categories.Setup, Actions.Import, {
        label: brand.name,
        value: null
      })
    }
    const onDelete = ({ id = null }) => {
      dispatch(deleteBrand({ id }))

      trackEv(Categories.Setup, Actions.Remove, {
        label: id, value: null
      })
    }

  return {
    onCreate,
    onDelete
  }
  } catch (error) {
    console.log(error, 'error')
    return {
      onCreate: () => { },
      onDelete: () => {  }

    }
  }
}

export default useBrandImporter
